<div class="dialog-container">

  <div class="header-buttons">
    <div class="right-buttons">
      <button color="primary" (click)="pageSidenav.toggle()" [disabled]="!isReadOnly" mat-stroked-button>
        @if (!isReadOnly) {
          {{
          "editar" | translate | titlecase
          }}
        }
        {{ "pagina" | translate }} {{ stepper.selectedIndex + 1 }}
        {{ "de" | translate }} {{ ayudasLength }}
      </button>
    </div>

    <div class="left-buttons">
      @if (isReadOnly) {
        <button
          *appHasPermission="{submoduleId: 76, type: 'isRead'}"
          matTooltip="{{ 'editar' | translate }}"
          color="primary"
          (click)="setEditMode()"
          mat-icon-button>
          <mat-icon fontSet="material-symbols-outlined">edit</mat-icon>
        </button>
      }

      <button
      matTooltip="{{
        (expandedDialog ? 'minimizar' : 'expandir') | translate
      }}"
        color="primary"
        (click)="expandDialog()"
        mat-icon-button
        >
        @if (expandedDialog) {
          <mat-icon fontSet="material-symbols-outlined"
            >close_fullscreen</mat-icon
            >
          }
          @if (!expandedDialog) {
            <mat-icon fontSet="material-symbols-outlined"
              >aspect_ratio</mat-icon
              >
            }
          </button>
          <button
            matTooltip="{{ 'cerrar' | translate }}"
            color="primary"
            color="warn"
            [mat-dialog-close]=""
            mat-icon-button
            >
            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
          </button>
        </div>
      </div>

      <mat-drawer-container class="help-container">
        <mat-drawer mode="over" #pageSidenav>
          <div class="sidenav-content">
            <mat-selection-list [multiple]="false">
              @for (ayudaGrouped of ayudas | keyvalue; track ayudaGrouped) {
                <div matSubheader>{{ayudaGrouped.key | translate | titlecase}}</div>
                @for (ayuda of ayudaGrouped.value; track ayuda) {
                  <mat-list-option
                    color="primary"
                    (click)="navigateTo(ayuda.idAyuda);pageSidenav.close()"
                    [value]="ayuda"
                    [selected]="currentHelp && (ayuda.idAyuda === currentHelp.idAyuda)">
                    <mat-label class="help-text-title" matListItemTitle>{{ ayuda.title }}</mat-label>
                    <span class="help-text-subtitle" matListItemLine>{{ ayuda.tipoAyuda | translate }} | {{ ayuda.tipoSubmodulo | translate }}</span>
                  </mat-list-option>
                }
              }
            </mat-selection-list>
          </div>
        </mat-drawer>
        <mat-drawer-content>

          <div class="mat-typography">
            <div class="stepper-container">
              <mat-stepper #stepper>
                @for (ayudaGrouped of ayudas | keyvalue; track ayudaGrouped) {
                  @for (ayuda of ayudaGrouped.value; track ayuda) {
                    <mat-step [label]="ayudaGrouped.key+','+ayuda.idAyuda">
                      <ng-template matStepContent>
                        <div>
                          <app-html-editor [inline]="'true'" [formControlEditing]="formControlEditing" [data]="ayuda.html" #htmlEditor></app-html-editor>
                        </div>
                      </ng-template>
                    </mat-step>
                  }
                }

              </mat-stepper>
            </div>
          </div>
        </mat-drawer-content>
      </mat-drawer-container>

      <div class="spacer"></div>

      <mat-dialog-actions align="end">
        @if (isReadOnly) {
          <button
            [disabled]="stepper.selectedIndex <= 0"
            class="icon-button"
            color="primary"
            (click)="stepper.previous()"
            mat-flat-button
            >
            <span>{{ "anterior" | translate | titlecase }}</span>
          </button>
          <button
            [disabled]="stepper.selectedIndex >= ayudasLength - 1"
            class="icon-button"
            color="primary"
            (click)="stepper.next()"
            mat-flat-button
            >
            <span>{{ "siguiente" | translate | titlecase }}</span>
          </button>
        }

        @if (!isReadOnly) {
          <button
            class="icon-button"
            color="primary"
            (click)="setEditMode()"
            mat-button
            >
            <span>{{ "cancelar" | translate | titlecase }}</span>
          </button>
          <button
            class="icon-button"
            color="primary"
            (click)="saveChanges()"
            mat-flat-button
            >
            <span>{{ "guardar" | translate | titlecase }}</span>
          </button>
        }
      </mat-dialog-actions>

    </div>
